import store from '@/store';
import * as logger from 'loglevel';
import prefix from 'loglevel-plugin-prefix';
// import remote from 'loglevel-plugin-remote';
import { app } from '@/bootloader';
import { config } from '@/config';
import { vueHooks } from './service';
import { IKLogLevel } from './loglevel.InjectionKeys';

logger.setLevel((config?.value?.logger?.level as keyof typeof logger.levels) || logger.levels.ERROR);
prefix.reg(logger);
prefix.apply(logger);
// remote.apply(logger, options.logLevelPluginRemote);
vueHooks(logger, app, store);
export { logger };
app.config.globalProperties.$iLog = logger;
app.provide(IKLogLevel, logger);
